import React from 'react';
import { useAuth } from '../../hooks/useAuth';

/**
 * Route garde pour la page d'accueil publique
 * - Permet l'accès à tous les utilisateurs (connectés ou non)
 * - La page publique doit être accessible même si l'utilisateur est connecté
 * - Les utilisateurs peuvent naviguer vers leur dashboard via les liens de navigation
 */
export const PublicLandingRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { loading } = useAuth();

  // Debug en développement
  React.useEffect(() => {
    if (process.env.NODE_ENV === 'development') {
      console.log('[PublicLandingRoute] Affichage de la LandingPage (publique)');
    }
  }, []);

  // Attendre le chargement de l'authentification
  // Pendant le chargement, afficher un loader minimal
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-600"></div>
      </div>
    );
  }

  // Toujours permettre l'accès à la page d'accueil (publique)
  // Les utilisateurs connectés peuvent toujours voir la page publique
  return <>{children}</>;
};

